module.exports = __webpack_public_path__ + "img/fondo3.4ac32fdb.jpg";